
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecoflow-stream-plug-in-thuisbatterij",
      function () {
        return require("private-next-pages/ecoflow-stream-plug-in-thuisbatterij/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecoflow-stream-plug-in-thuisbatterij"])
      });
    }
  